import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

interface MobileLayoutFixProps {
  children: React.ReactNode;
}

/**
 * Componente wrapper que corrige problemas de layout em mobile
 * Garante que o header não sobreponha o conteúdo após navegação
 */
const MobileLayoutFix: React.FC<MobileLayoutFixProps> = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Pequeno delay para garantir que o DOM está completamente renderizado
    const timer = setTimeout(() => {
      setIsReady(true);
      
      // Forçar recálculo de layout
      const mainElement = document.querySelector('main');
      if (mainElement) {
        const computedStyle = window.getComputedStyle(mainElement);
        const paddingTop = computedStyle.paddingTop;
        
        // Se não houver padding suficiente, adicionar
        if (parseInt(paddingTop) < 56) {
          mainElement.style.paddingTop = '56px';
          
          // Resetar após um pequeno delay
          setTimeout(() => {
            mainElement.style.paddingTop = '';
          }, 100);
        }
      }
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        opacity: isReady ? 1 : 0,
        transition: 'opacity 0.1s ease-in-out',
        height: '100%',
        width: '100%'
      }}
    >
      {children}
    </Box>
  );
};

export default MobileLayoutFix;